module.exports = __webpack_public_path__ + "img/Player-active.2fe6453c.svg";